import { ViewModel, View, ViewModelMessage } from "binder"
import { AuthenticationViewModel, LoginCompletedMessage } from "src/security/authentication/authentication-viewModel";
import { ExecuteLocalNotificationMessage, LocalNotification, LocalNotificationMessage } from "src/server/localNotification";
import { ServerConnection } from "src/server/serverConnection";
import { ThemeSelectorViewModel } from "../themeSelector/themeSelector-viewModel";
import { UserMainWindowViewModel } from "../userMainWindow/userMainWindow-viewModel";
import { MainWindowView } from "./mainWindow-view"
import { CurrentCredentials } from "src/server/currentCredentials";

export class MainWindowViewModel extends ViewModel {
    private themes : Map<string,string>;
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this._macAddressCheckCount =0;
        this.updateThemeMappings();
        this.localNotification = new LocalNotification(()=>"",()=>"");
        this.content = new AuthenticationViewModel(this);
        this.stableBackground = 'linear-gradient(-45deg, #29323c, #485563)';
        this.transitionBackground = 'linear-gradient(-45deg, #29323c, #485563)';
        this.checkForMacAddresses();

        this.loadLastBackgroundImage();
    }

    GetDefaultView(): View<ViewModel> {
        return new MainWindowView();
    }
    public getTypeId(): string {
        return "VM-88B5598D-CA0D-4C8B-A023-66AE3131C1BB"
    }
    private _macAddressCheckCount : number;
    async checkForMacAddresses(){
        try{
            let result = await this.handleMessage(new ExecuteLocalNotificationMessage('getSystemMacAddresses',null));
            CurrentCredentials.macAddresses =JSON.parse(result);
            this._macAddressCheckCount = 0;
        }catch{
            this._macAddressCheckCount += 1;
            if(this._macAddressCheckCount>=3){
                CurrentCredentials.macAddresses = [];
            }
        }finally{
            console.log(CurrentCredentials.macAddresses);
            setTimeout(() => {
                this.checkForMacAddresses();
            }, 3000);
        }
    }

    private localNotification: LocalNotification;
    private updateThemeMappings(){
        this.themes = new Map<string,string>();
        this.themes.set('1','/res/bg1.jpg');
        this.themes.set('2','/res/bg2.jpg');
        this.themes.set('3','/res/bg3.jpg');
        this.themes.set('4','/res/bg4.jpg');
        this.themes.set('5','/res/bg5.jpg');
        this.themes.set('6','/res/bg6.jpg');
        this.themes.set('7','linear-gradient(45deg, #0c675e, #069e90)');
        this.themes.set('8','linear-gradient( 567deg , rgba(165, 42, 4, 0.89), rgba(113, 102, 8, 0.89), rgba(13, 95, 16, 0.93), rgba(4, 79, 88, 0.94), rgba(19, 56, 86, 0.9), rgba(24, 32, 78, 0.94), rgba(100, 8, 115, 0.95))');
        this.themes.set('9','linear-gradient(45deg, #29323c, #485563)');
        this.themes.set('10','linear-gradient(45deg, #795548, #945c48)');
        this.themes.set('11','linear-gradient(180deg, #0f27d3, #13084e)');
        this.themes.set('12','linear-gradient(45deg, #65379b, #886aea)');
        this.themes.set('13','linear-gradient(180deg, #666467, #403e41)');
        this.themes.set('14','linear-gradient(180deg, #009205, #2b4b04)');
        this.themes.set('15','linear-gradient(45deg, #6a11cb, #2575fc)');
    }

    handleMessage(message: ViewModelMessage) {
        if (message instanceof LoginCompletedMessage) {
            this.content = new UserMainWindowViewModel(this);
        } else if (message instanceof LocalNotificationMessage) {
            return this.localNotification.handleMessage(message)
        } else if (message instanceof ChangeThemeMessage) {
            let themeId = message.background ?? "4";
            let background = this.themes.get(themeId);
            if(themeId==null)
                background = '/res/bg4.jpg';
            this.updateBackgroundImage(background);
            if(message.shallSave){
                this.saveUserTheme(themeId);
            }
            return null;
        } else {
            return super.handleMessage(message);
        }
    }
    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content; } private _content: ViewModel;
    public set stableBackground(v: string) { this._stableBackground = v; } public get stableBackground(): string { return this._stableBackground; } private _stableBackground: string;
    public set transitionBackground(v: string) { this._transitionBackground = v; } public get transitionBackground(): string { return this._transitionBackground; } private _transitionBackground: string;
    public set transitioning(v: boolean) { this._transitioning = v; } public get transitioning(): boolean { return this._transitioning; } private _transitioning: boolean;
    
    async loadLastBackgroundImage() {
        let backgroundImage = localStorage.getItem("main-window-background-image");
        if (backgroundImage == null) {
            this.updateBackgroundImage('/res/bg4.jpg');
        } else {
            this.updateBackgroundImage(backgroundImage);
        }
    }

    private readBlob(b):Promise<string> {
        return new Promise(function (resolve, reject) {
            const reader = new FileReader();

            reader.onloadend = function () {
                resolve(<string>reader.result);
            };
            reader.onerror = function(){
                reject();
            }
            // TODO: hook up reject to reader.onerror somehow and try it

            reader.readAsDataURL(b);
        });
    }
    private lastRequestTime;
    async updateBackgroundImage(background: string) {
        let requestTime = new Date().getTime();
        let backgroundImage = background;
        this.lastRequestTime = requestTime;
        if (background.startsWith('/res/')) {
            let response = await fetch(background);
            const blob = await response.blob();
            backgroundImage = await this.readBlob(blob);
            backgroundImage = `url('${backgroundImage}')`;
            if(requestTime<this.lastRequestTime)
                return;
        }
        localStorage.setItem("main-window-background-image",background);
        this.applyBackgroundImage(backgroundImage);
    }

    private applyBackgroundImage(content:string){
        this.stableBackground = content;
        this.transitioning = true;
        setTimeout(()=>{
            this.transitionBackground = content;
            this.transitioning = false;
        },300)
    }
    async saveUserTheme(themeId:string){
        try {
            let result = await ServerConnection.callServer('/Complex/AuthenticationServices/UpdateCurrentUserTheme',{
                ThemeId : themeId
            });
        } catch (ex) {
        } finally {
        }
    }
}

export class ChangeThemeMessage extends ViewModelMessage{
    public background:string;
    public shallSave:boolean;
}